import { get, x64hash128 } from 'fingerprintjs2';
import { generate_uuid, read_cookie, create_cookie, jsonp, get_os } from './utils';
import { logger } from './logger';
import { store } from './store';
import { isWxMiniProgram, isAlipayMiniProgram } from './env';
var uid_key = '__ca_uid_key__';
var uuid_key = '__ca_uuid_key__';
export function get_device(domain) {
    var metrics = {};
    if (isWxMiniProgram || isAlipayMiniProgram) {
        var Sdk = isWxMiniProgram ? wx : my;
        try {
            var miniappSystemInfo = Sdk.getSystemInfoSync();
            var platform = miniappSystemInfo.platform, system = miniappSystemInfo.system, pixelRatio = miniappSystemInfo.pixelRatio, screenHeight = miniappSystemInfo.screenHeight, screenWidth = miniappSystemInfo.screenWidth, language = miniappSystemInfo.language, wifiEnabled = miniappSystemInfo.wifiEnabled;
            metrics.platform = platform;
            metrics.la = language;
            metrics.ua = system;
            metrics.net = wifiEnabled ? 'wifi' : '4g';
            metrics.density = pixelRatio;
            metrics.cpu = 0;
            metrics.resolution = screenWidth + "x" + screenHeight;
            metrics.process_id = generate_uuid();
            var store_uid_key = store(uid_key);
            if (!store_uid_key) {
                metrics.uid = generate_uuid();
                store(uid_key, {}, metrics.uid);
            }
            else {
                metrics.uid = store_uid_key;
            }
            var store_uuid_key = store(uuid_key);
            if (store_uuid_key) {
                metrics.uuid = store_uuid_key;
            }
            Sdk.request({
                url: 'https://pv.sohu.com/cityjson?ie=utf-8',
                dataType: 'text',
                method: 'GET',
                success: function (res) {
                    var pattern = /((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/g;
                    if (res && res.data) {
                        metrics.ip = res.data.match(pattern)[0];
                    }
                    else {
                        metrics.ip = '';
                    }
                    var custom_options = {
                        excludes: {
                            screenResolution: true,
                            availableScreenResolution: true,
                            enumerateDevices: true,
                            fontsFlash: true,
                            pixelRatio: true,
                            doNotTrack: true,
                            cpuClass: true,
                            plugins: true,
                            adBlock: true,
                            webdriver: true,
                            language: true,
                            colorDepth: true,
                            deviceMemory: true,
                            hardwareConcurrency: true,
                            timezoneOffset: true,
                            timezone: true,
                            sessionStorage: true,
                            localStorage: true,
                            indexedDb: true,
                            addBehavior: true,
                            openDatabase: true,
                            platform: true,
                            canvas: true,
                            webgl: true,
                            webglVendorAndRenderer: true,
                            hasLiedLanguages: true,
                            hasLiedResolution: true,
                            hasLiedOs: true,
                            hasLiedBrowser: true,
                            touchSupport: true,
                            fonts: true,
                            audio: true,
                        },
                        extraComponents: [
                            {
                                key: 'ip',
                                getData: function (done, options) {
                                    done("" + metrics.ip);
                                },
                            },
                        ],
                        NOT_AVAILABLE: 'not available',
                        ERROR: 'error',
                        EXCLUDED: 'excluded',
                    };
                    get(custom_options, function (components) {
                        var values = components.map(function (component) {
                            return component.value;
                        });
                        var store_uuid_key = store(uuid_key);
                        var i = 0;
                        var uuid = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, function (c) { return (x64hash128(values.join(''), 31)[i++]); });
                        if (!store_uuid_key) {
                            metrics.uuid = uuid;
                            store(uuid_key, {}, uuid);
                        }
                        else {
                            metrics.uuid = store_uuid_key;
                        }
                    });
                },
                fail: function () {
                    metrics.ip = '';
                    metrics.uuid = '';
                },
            });
        }
        catch (e) {
            console.log(e);
        }
    }
    else {
        if (screen.width) {
            var width = screen.width ? parseInt("" + screen.width) : 0;
            var height = screen.height ? parseInt("" + screen.height) : 0;
            if (width !== 0 && height !== 0) {
                var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
                if (iOS && window.devicePixelRatio) {
                    width = Math.round(width * window.devicePixelRatio);
                    height = Math.round(height * window.devicePixelRatio);
                }
                else {
                    if (Math.abs(window.orientation) === 90) {
                        var temp = width;
                        width = height;
                        height = temp;
                    }
                }
                metrics.resolution = width + "x" + height;
            }
        }
        metrics.ua = navigator.userAgent;
        metrics.platform = get_os();
        if (navigator.connection) {
            metrics.net = navigator.connection.effectiveType;
        }
        metrics.cpu = navigator.hardwareConcurrency;
        if (window.devicePixelRatio) {
            metrics.density = window.devicePixelRatio;
        }
        metrics.process_id = generate_uuid();
        var store_uid_key = read_cookie(uid_key);
        if (!store_uid_key) {
            create_cookie(uid_key, (metrics.uid = generate_uuid()), 30, domain);
        }
        else {
            metrics.uid = store_uid_key;
        }
        metrics.la = navigator.language;
        if (window.devicePixelRatio) {
            metrics.density = window.devicePixelRatio;
        }
        jsonp('https://pv.sohu.com/cityjson?ie=utf-8', function () {
            metrics.ip = window.returnCitySN.cip;
            var custom_options = {
                excludes: {
                    screenResolution: true,
                    availableScreenResolution: true,
                    enumerateDevices: true,
                    fontsFlash: true,
                    pixelRatio: true,
                    doNotTrack: true,
                    cpuClass: true,
                    plugins: true,
                    adBlock: true,
                    webdriver: true,
                    language: true,
                    colorDepth: true,
                    deviceMemory: true,
                    hardwareConcurrency: true,
                    timezoneOffset: true,
                    timezone: true,
                    sessionStorage: true,
                    localStorage: true,
                    indexedDb: true,
                    addBehavior: true,
                    openDatabase: true,
                    platform: true,
                    canvas: true,
                    webgl: true,
                    webglVendorAndRenderer: true,
                    hasLiedLanguages: true,
                    hasLiedResolution: true,
                    hasLiedOs: true,
                    hasLiedBrowser: true,
                    touchSupport: true,
                    fonts: true,
                    audio: true,
                },
                extraComponents: [
                    {
                        key: 'ip',
                        getData: function (done, options) {
                            done("" + window.returnCitySN.cip);
                        },
                    },
                ],
                NOT_AVAILABLE: 'not available',
                ERROR: 'error',
                EXCLUDED: 'excluded',
            };
            get(custom_options, function (components) {
                var values = components.map(function (component) {
                    return component.value;
                });
                var store_uuid_key = store(uuid_key);
                var i = 0;
                var uuid = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, function (c) { return (x64hash128(values.join(''), 31)[i++]); });
                if (!store_uuid_key) {
                    metrics.uuid = uuid;
                    store(uuid_key, {}, uuid);
                }
                else {
                    metrics.uuid = store_uuid_key;
                }
            });
        });
    }
    logger('Got metrics', metrics);
    return metrics;
}
